import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONTACT_INFO } from '../../constants/data';

interface FooterProps {
  showResume?: boolean;
  lng?: string;
}

export const Footer: React.FC<FooterProps> = ({ showResume = true, lng }) => {
  const { t: tDefault, i18n } = useTranslation();
  const t = lng ? i18n.getFixedT(lng) : tDefault;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 py-12 text-slate-500 border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-slate-800 rounded flex items-center justify-center text-slate-400 font-bold text-xs">
            JA
          </div>
          <span className="font-semibold text-slate-300">Aarón García</span>
        </div>

        <div className="text-sm">
          © {currentYear} {t('footer.rights')}
        </div>

        <div className="flex gap-6">
          {showResume && (
            <a
              href={CONTACT_INFO.portfolioUrl}
              className="hover:text-white transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.portfolio')}
            </a>
          )}
          <a
            href={CONTACT_INFO.linkedin}
            className="hover:text-white transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('footer.linkedin')}
          </a>
        </div>
      </div>
    </footer>
  );
};

